import { Box, BoxProps } from '@chakra-ui/react';
import QRCode, { QRCodeProps } from 'components/QrCode';
import React from 'react';

interface DownloadAppQrCodeProps extends BoxProps {
  downloadLink?: string;
  qrCodeProps?: Omit<QRCodeProps, 'downloadLink'>;
}

const DownloadAppQrCode = ({
  downloadLink,
  qrCodeProps = {},
  ...props
}: DownloadAppQrCodeProps) => {
  return (
    <Box {...props}>
      <QRCode
        downloadLink={downloadLink ?? ''}
        width="100px"
        height="100px"
        padding="10px"
        bgColor="neutral.0"
        borderRadius="10px"
        {...qrCodeProps}
      />
    </Box>
  );
};

export default DownloadAppQrCode;
